/**
 * T-289 (Sascha Hahn, 12.10.2026): „cbb bitte als Standard-Postfach festlegen
 * statt sah" — PO: „muss man einstellen können". Wer fast alles über cbb@
 * verschickt, musste das Absenderfeld bei jeder neuen Mail und jeder Antwort
 * auf eine Mail aus dem eigenen Postfach von Hand umstellen.
 *
 * ENTSCHEIDUNG (28.10.2026), wann der Standard-Absender gilt:
 *  - bei NEUEN Mails (auch „Mail schreiben" im Vorgang und aus einem anderen
 *    geöffneten Postfach heraus),
 *  - bei Antworten/Weiterleitungen auf Mails aus dem EIGENEN Postfach,
 *  - als Rückfall, wenn die Ursprungsmail in einem Postfach liegt, aus dem man
 *    nicht senden darf.
 * Liegt die Ursprungsmail in einem GETEILTEN Postfach, aus dem man senden darf
 * (etwa schaden@), bleibt dieses — die Antwort gehört dorthin.
 *
 * Ohne Einstellung bleibt alles wie bisher. Entwürfe berührt das nicht (deren
 * Postfach steht fest); das regelt der Aufrufer.
 */

/** Scope in der `UserPreference`-Ablage (pro Person, serverseitig gespeichert). */
export const STANDARD_ABSENDER_SCOPE = "mail.standardAbsender";

const klein = (adresse: string | null | undefined): string => (adresse ?? "").trim().toLowerCase();

/** Nur eine Adresse ist ein Standard-Absender; alles andere = keiner (`null`). */
export function normalisiereStandardAbsender(roh: unknown): string | null {
    if (typeof roh !== "string") return null;
    const adresse = klein(roh);
    return adresse.includes("@") ? adresse : null;
}

export function startAbsender(p: {
    /** `mailbox`-Parameter des Fensters (bei Antworten das Postfach der Ursprungsmail). */
    vorgabe?: string | null;
    /** Das gerade geöffnete Postfach der Mail-App. */
    aktuellesPostfach?: string | null;
    /**
     * Wo die Ursprungsmail liegt (`replySourceMailbox`) — nur bei Antworten und
     * Weiterleitungen echter Postfach-Mails. Leer = neue Mail.
     */
    ursprungsPostfach?: string | null;
    /** Das eigene Postfach der Person. */
    eigenesPostfach?: string | null;
    /** Einstellung „Standard-Absender"; leer = wie bisher. */
    standardAbsender?: string | null;
    /** Adressen der Postfächer, aus denen die Person senden darf. */
    sendbar: readonly string[];
}): string | null {
    const bisher = p.vorgabe ?? p.aktuellesPostfach ?? null;
    // Die Adresse so, wie sie in der Auswahl steht (der `<select>` vergleicht exakt).
    const sendbareAdresse = (adresse: string | null | undefined): string | null => {
        const gesucht = klein(adresse);
        if (!gesucht) return null;
        return p.sendbar.find((m) => klein(m) === gesucht) ?? null;
    };

    const standard = sendbareAdresse(p.standardAbsender);
    if (!standard) return bisher;

    const ursprung = klein(p.ursprungsPostfach);
    const ausGeteiltemPostfach = !!ursprung && ursprung !== klein(p.eigenesPostfach);
    if (ausGeteiltemPostfach && sendbareAdresse(ursprung)) return bisher;
    return standard;
}
